/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EmailTemplate } from '../../types/emailTemplateTypes';

export interface EmailTemplatesState {
  templates: EmailTemplate[];
  selectedTemplate: EmailTemplate | null;
  fetchTemplatesLoading: boolean;
  createTemplateLoading: boolean;
  updateTemplateLoading: boolean;
  deleteTemplateLoading: boolean;
  error: string | null;
}

const initialState: EmailTemplatesState = {
  templates: [],
  selectedTemplate: null,
  fetchTemplatesLoading: false,
  createTemplateLoading: false,
  updateTemplateLoading: false,
  deleteTemplateLoading: false,
  error: null,
};

type EmailTemplatesLoadingKey =
  | 'fetchTemplatesLoading'
  | 'createTemplateLoading'
  | 'updateTemplateLoading'
  | 'deleteTemplateLoading';

const emailTemplatesSlice = createSlice({
  name: 'emailTemplates',
  initialState,
  reducers: {
    fetchEmailTemplates(state, _action: PayloadAction<{ orgId: number }>) {
      state.error = null;
    },
    createEmailTemplate(
      _state,
      _action: PayloadAction<{
        orgId: number;
        template: Partial<EmailTemplate>;
      }>,
    ) {},
    updateEmailTemplate(
      _state,
      _action: PayloadAction<{
        orgId: number;
        templateId: number;
        template: Partial<EmailTemplate>;
      }>,
    ) {},
    deleteEmailTemplate(
      _state,
      _action: PayloadAction<{ orgId: number; templateId: number }>,
    ) {},

    setTemplates(state, action: PayloadAction<EmailTemplate[]>) {
      state.templates = action.payload;
    },
    setSelectedTemplate(state, action: PayloadAction<EmailTemplate | null>) {
      state.selectedTemplate = action.payload;
    },
    setLoading(
      state,
      action: PayloadAction<{ key: EmailTemplatesLoadingKey; value: boolean }>,
    ) {
      state[action.payload.key] = action.payload.value;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    clearEmailTemplateState() {
      return initialState;
    },
  },
});

export const {
  fetchEmailTemplates,
  createEmailTemplate,
  updateEmailTemplate,
  deleteEmailTemplate,
  setTemplates,
  setSelectedTemplate,
  setLoading,
  setError,
  clearEmailTemplateState,
} = emailTemplatesSlice.actions;

export const emailTemplatesActions = emailTemplatesSlice.actions;
export default emailTemplatesSlice.reducer;
